import { useEffect, memo } from 'react';
import { replaceWindowLocationHref } from '../../../../utils';
import { useAppStoreReviewMode } from '../../../../hooks/useAppStoreReviewMode';
import service from '../../../../services';

const GameDirectRun = memo(({ gameURL, launchPayload }) => {
  const isReviewMode = useAppStoreReviewMode();

  useEffect(() => {
    if (isReviewMode && launchPayload) {
      service.publish('event', 'game:launch', launchPayload);
    }
  }, [isReviewMode, launchPayload]);

  useEffect(() => {
    if (gameURL && !isReviewMode) {
      replaceWindowLocationHref(gameURL);
    }
  }, [gameURL, isReviewMode]);

  /* eslint-disable react/no-danger */
  return null;
  /* eslint-enable react/no-danger */
});

export default GameDirectRun;
